import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ScheduleItem, Website } from './wedding';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { BaseObject } from '../shared/baseClass';
import { RegistryService } from '../registry/registry.service';
import { AuthService, User } from '../user/auth.service';
import { default as defaultWebsiteCeline } from '../website-template-celine/default-data';
import { SettingsStateStore } from '../settings/settings.state.store';
import { Settings } from '../settings/settings';
import { map, flatMap } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { Registry } from '../registry/registry';

import { forEach } from '@angular/router/src/utils/collection';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { ImageUrlService } from '../shared/services/image-url.service';
export interface State {
  website: Website;
  settings: Settings;
  user: User | null;
  groupedScheduleItems: any[],
  customFonts: any[]
}

@Injectable()
export class WebsiteStateStore {
  private state$: BehaviorSubject<State>;
  private userId: string;
  private registry: Registry = null;
  private user: User;
  private scrollToEditorSource = new Subject<string>();
  scrolltoSource$ = this.scrollToEditorSource.asObservable();
  private emitTranslationSource = new Subject<boolean>();
  settings: Settings;
  tranlsationEmitted$ = this.emitTranslationSource.asObservable();
  allSections = [

    'story',
    'schedule',
    'rsvp',
    'weddingParty',
    'travel',
    'questions',
    'registry',


  ];

  templateDefaults = [
    {
      id: `template1`,
      fonts: {
        heading: 'Roboto',
        paragraph: 'Inter Variable',
        misc: 'Lato'
      },
      colors: {
        light: '#F4F3E9',
        dark: '#E4DDCA',
        lightAccent: '#EEFC86',
        darkAccent: '#B2C0AD',
        accent: '#242E22'
      }
    },
    {
      id: `template2`,
      fonts: {
        heading: 'Inter Variable',
        paragraph: 'Roboto',
        misc: 'Inter Variable'
      },
      colors: {
        light: '#F4F3E9',
        dark: '#E4DDCA',
        lightAccent: '#EEFC86',
        darkAccent: '#B2C0AD',
        accent: '#242E22'
      },
    },
    {
      id: `celine`,
      fonts: {
        heading: 'Inter Variable',
        paragraph: 'Roboto',
        misc: 'Inter Variable'
      },
      colors: {
        light: '#F4F3E9',
        dark: '#E4DDCA',
        lightAccent: '#EEFC86',
        darkAccent: '#B2C0AD',
        accent: '#242E22'
      },
    },
    {
      id: `lottie`,
      fonts: {
        heading: 'Inter Variable',
        paragraph: 'Roboto',
        misc: 'Inter Variable'
      },
      colors: {
        light: '#F4F3E9',
        dark: '#E4DDCA',
        lightAccent: '#EEFC86',
        darkAccent: '#B2C0AD',
        accent: '#242E22'
      }
    }
  ]
  FIRESTORE_WEBSITES_DOCUMENT_COLLECTION_NAME = 'websites';
  WEBSITES_SETTINGS_COLLECTION_NAME = 'settings';
  public googleFonts: any =


    [

      {
        "name": "Roboto",
        "file": "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Me5WZLCzYlKw.ttf"
      },
      {
        "name": "Open Sans",
        "file": "https://fonts.gstatic.com/s/opensans/v40/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4nY1M2xLER.ttf"
      },
      {
        "name": "Lato",
        "file": "https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHvxk6XweuBCY.ttf"
      },
      {
        "name": "Montserrat",
        "file": "https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Ew-Y3tcoqK5.ttf"
      },
      {
        "name": "Poppins",
        "file": "https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf"
      },
      {
        "name": "Roboto Mono",
        "file": "https://fonts.gstatic.com/s/robotomono/v23/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vqPQ--5Ip2sSQ.ttf"
      },


      {
        "name": "Inter Bold",
        "file": "https://cdnjs.cloudflare.com/ajax/libs/inter-ui/4.0.2/web/Inter-Bold.woff2"
      },


      {
        "name": "Inter Medium",
        "file": "https://cdnjs.cloudflare.com/ajax/libs/inter-ui/4.0.2/web/Inter-Medium.woff2"
      },


      {
        "name": "Inter",
        "file": "https://cdnjs.cloudflare.com/ajax/libs/inter-ui/4.0.2/web/Inter-Regular.woff2"
      },


      {
        "name": "Inter Semi Bold",
        "file": "https://cdnjs.cloudflare.com/ajax/libs/inter-ui/4.0.2/web/Inter-SemiBold.woff2"
      },
      {
        "name": "Inter Display Bold",
        "file": "https://cdnjs.cloudflare.com/ajax/libs/inter-ui/4.0.2/display/InterDisplay.woff2"
      },

      {
        "name": "Inter Display Bold",
        "file": "https://cdnjs.cloudflare.com/ajax/libs/inter-ui/4.0.2/display/InterDisplay-Bold.woff2"
      },


      {
        "name": "Inter Display Medium",
        "file": "https://cdnjs.cloudflare.com/ajax/libs/inter-ui/4.0.2/display/InterDisplay-Medium.woff2"
      },


      {
        "name": "Inter Display Regular",
        "file": "https://cdnjs.cloudflare.com/ajax/libs/inter-ui/4.0.2/display/InterDisplay-Regular.woff2"
      },


      {
        "name": "Inter Display Semi Bold",
        "file": "https://cdnjs.cloudflare.com/ajax/libs/inter-ui/4.0.2/display/InterDisplay-SemiBold.woff2"
      },


      {
        "name": "Inter Variable",
        "file": "https://cdnjs.cloudflare.com/ajax/libs/inter-ui/4.0.2/variable/InterVariable.woff2"
      },

      {
        "name": "Roboto Condensed",
        "file": "https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyWyovBJ731BKMSK.ttf"
      },
      {
        "name": "Inconsolata",
        "file": "https://fonts.gstatic.com/s/inconsolata/v32/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp4U8aRr8lleY2co.ttf"
      },
      {
        "name": "Oswald",
        "file": "https://fonts.gstatic.com/s/oswald/v53/TK3_WkUHHAIjg75cFRf3bXL8LICs1_FvgUFoZAaRliE.ttf"
      },
      {
        "name": "Noto Sans JP",
        "file": "https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFBEj75vY0rw-oME.ttf"
      },
      {
        "name": "Raleway",
        "file": "https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaooCPNLA3JC9c.ttf"
      },
      {
        "name": "Noto Sans",
        "file": "https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyD9A99d41P6zHtY.ttf"
      },
      {
        "name": "Roboto Slab",
        "file": "https://fonts.gstatic.com/s/robotoslab/v34/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjojISWaG5iddG-1A.ttf"
      },
      {
        "name": "Source Code Pro",
        "file": "https://fonts.gstatic.com/s/sourcecodepro/v23/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DMyQhM5hTXUcdJg.ttf"
      },

      {
        "name": "Nunito Sans",
        "file": "https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4G1ilntF8kA_Ykqw.ttf"
      },
      {
        "name": "Rubik",
        "file": "https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4i1UE80V4bVkA.ttf"
      },
      {
        "name": "Nunito",
        "file": "https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDLshRTM9jo7eTWk.ttf"
      },
      {
        "name": "Noto Sans TC",
        "file": "https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz76Cy_CpOtma3uNQ.ttf"
      },
      {
        "name": "Playfair Display",
        "file": "https://fonts.gstatic.com/s/playfairdisplay/v37/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKdFvUDQZNLo_U2r.ttf"
      },
      {
        "name": "Merriweather",
        "file": "https://fonts.gstatic.com/s/merriweather/v30/u-440qyriQwlOrhSvowK_l5OeyxNV-bnrw.ttf"
      },
      {
        "name": "Ubuntu",
        "file": "https://fonts.gstatic.com/s/ubuntu/v20/4iCs6KVjbNBYlgo6eAT3v02QFg.ttf"
      },
      {
        "name": "Space Grotesk",
        "file": "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mQoQDjQSkFtoMM3T6r8E7mF71Q-gOoraIAEj7oUUsjNsFjTDJK.ttf"
      },
      {
        "name": "Work Sans",
        "file": "https://fonts.gstatic.com/s/worksans/v19/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nXNigDp6_cOyA.ttf"
      },
      {
        "name": "PT Sans",
        "file": "https://fonts.gstatic.com/s/ptsans/v17/jizaRExUiTo99u79P0WOxOGMMDQ.ttf"
      },
      {
        "name": "Manrope",
        "file": "https://fonts.gstatic.com/s/manrope/v15/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk79FO_F87jxeN7B.ttf"
      },
      {
        "name": "Fira Sans",
        "file": "https://fonts.gstatic.com/s/firasans/v17/va9E4kDNxMZdWfMOD5VfkILKSTbndQ.ttf"
      },
      {
        "name": "Barlow",
        "file": "https://fonts.gstatic.com/s/barlow/v12/7cHpv4kjgoGqM7EPC8E46HsxnA.ttf"
      },
      {
        "name": "Kanit",
        "file": "https://fonts.gstatic.com/s/kanit/v15/nKKZ-Go6G5tXcoaSEQGodLxA.ttf"
      },
      {
        "name": "Noto Sans KR",
        "file": "https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzuoyeLTq8H4hfeE.ttf"
      },
      {
        "name": "Lora",
        "file": "https://fonts.gstatic.com/s/lora/v35/0QI6MX1D_JOuGQbT0gvTJPa787weuyJGmKxemMeZ.ttf"
      },
      {
        "name": "Cairo",
        "file": "https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hOA-W1ToLQ-HmkA.ttf"
      },
      {
        "name": "DM Sans",
        "file": "https://fonts.gstatic.com/s/dmsans/v14/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAopxhTmf3ZGMZpg.ttf"
      },
      {
        "name": "Mulish",
        "file": "https://fonts.gstatic.com/s/mulish/v13/1Ptyg83HX_SGhgqO0yLcmjzUAuWexZNRwaClGrw-PTY.ttf"
      },
      {
        "name": "Quicksand",
        "file": "https://fonts.gstatic.com/s/quicksand/v31/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkP8o18G0wx40QDw.ttf"
      },
      {
        "name": "IBM Plex Sans Arabic",
        "file": "https://fonts.gstatic.com/s/ibmplexsansarabic/v12/Qw3CZRtWPQCuHme67tEYUIx3Kh0PHR9N6bs61vSbfdlA.ttf"
      },
      {
        "name": "Noto Sans Arabic",
        "file": "https://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfyGyvu3CBFQLaig.ttf"
      },
      {
        "name": "Titillium Web",
        "file": "https://fonts.gstatic.com/s/titilliumweb/v17/NaPecZTIAOhVxoMyOr9n_E7fRMTsDIRSfr0.ttf"
      },
      {
        "name": "Libre Franklin",
        "file": "https://fonts.gstatic.com/s/librefranklin/v14/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhLsWUB9rIb-JH1g.ttf"
      },
      {
        "name": "Libre Baskerville",
        "file": "https://fonts.gstatic.com/s/librebaskerville/v14/kmKnZrc3Hgbbcjq75U4uslyuy4kn0pNeYRI4CN2V.ttf"
      },

      {
        "name": "PT Serif",
        "file": "https://fonts.gstatic.com/s/ptserif/v18/EJRVQgYoZZY2vCFuvDFRxL6ddjb-.ttf"
      },
      {
        "name": "Karla",
        "file": "https://fonts.gstatic.com/s/karla/v31/qkBIXvYC6trAT55ZBi1ueQVIjQTD-JqqFENLR7fHGw.ttf"
      },
      {
        "name": "Josefin Sans",
        "file": "https://fonts.gstatic.com/s/josefinsans/v32/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_DjQXMFrLgTsQV0.ttf"
      },
      {
        "name": "IBM Plex Sans",
        "file": "https://fonts.gstatic.com/s/ibmplexsans/v19/zYXgKVElMYYaJe8bpLHnCwDKtdbUFI5NadY.ttf"
      },
      {
        "name": "Tajawal",
        "file": "https://fonts.gstatic.com/s/tajawal/v9/Iura6YBj_oCad4k1rzaLCr5IlLA.ttf"
      },
      {
        "name": "Tenor Sans",
        "file": "https://fonts.gstatic.com/s/tenorsans/v19/bx6ANxqUneKx06UkIXISr3JyC22IyqI.ttf"
      },
      {
        "name": "Dosis",
        "file": "https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJN7MV3BkFTq4EPw.ttf"
      },
      {
        "name": "Noto Serif",
        "file": "https://fonts.gstatic.com/s/notoserif/v23/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZqFCjwM0Lhq_Szw.ttf"
      },
      {
        "name": "Pacifico",
        "file": "https://fonts.gstatic.com/s/pacifico/v22/FwZY7-Qmy14u9lezJ96A4sijpFu_.ttf"
      },
      {
        "name": "Bebas Neue",
        "file": "https://fonts.gstatic.com/s/bebasneue/v14/JTUSjIg69CK48gW7PXooxW5rygbi49c.ttf"
      },
      {
        "name": "Heebo",
        "file": "https://fonts.gstatic.com/s/heebo/v26/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiSycckOnz02SXQ.ttf"
      },
      {
        "name": "Bitter",
        "file": "https://fonts.gstatic.com/s/bitter/v33/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8fbfCL_EXFh2reU.ttf"
      },
      {
        "name": "Archivo",
        "file": "https://fonts.gstatic.com/s/archivo/v19/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTNDNp8B1oJ0vyVQ.ttf"
      },
      {
        "name": "Cabin",
        "file": "https://fonts.gstatic.com/s/cabin/v27/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkV2EL7Gvxm7rE_s.ttf"
      },

      {
        "name": "Almarai",
        "file": "https://fonts.gstatic.com/s/almarai/v12/tsstApxBaigK_hnnc1qPonC3vqc.ttf"
      },
      {
        "name": "Arimo",
        "file": "https://fonts.gstatic.com/s/arimo/v29/P5sfzZCDf9_T_3cV7NCUECyoxNk37cxsBxDAVQI4aA.ttf"
      },

      {
        "name": "Overpass",
        "file": "https://fonts.gstatic.com/s/overpass/v13/qFda35WCmI96Ajtm83upeyoaX6QPnlo6_PPrOZCLtce-og.ttf"
      },
      {
        "name": "Dancing Script",
        "file": "https://fonts.gstatic.com/s/dancingscript/v25/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7BMSoHTeB9ptDqpw.ttf"
      },
      {
        "name": "Varela Round",
        "file": "https://fonts.gstatic.com/s/varelaround/v20/w8gdH283Tvk__Lua32TysjIvoMGOD9gxZw.ttf"
      },
      {
        "name": "Oxygen",
        "file": "https://fonts.gstatic.com/s/oxygen/v15/2sDfZG1Wl4Lcnbu6iUcnZ0SkAg.ttf"
      },
      {
        "name": "Shadows Into Light",
        "file": "https://fonts.gstatic.com/s/shadowsintolight/v19/UqyNK9UOIntux_czAvDQx_ZcHqZXBNQDcsr4xzSMYA.ttf"
      },
      {
        "name": "Jost",
        "file": "https://fonts.gstatic.com/s/jost/v15/92zPtBhPNqw79Ij1E865zBUv7myjJQVGPokMmuHL.ttf"
      },
      {
        "name": "Caveat",
        "file": "https://fonts.gstatic.com/s/caveat/v18/WnznHAc5bAfYB2QRah7pcpNvOx-pjfJ9SIKjYBxPigs.ttf"
      },
      {
        "name": "EB Garamond",
        "file": "https://fonts.gstatic.com/s/ebgaramond/v27/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-6_RUA4V-e6yHgQ.ttf"
      },
      {
        "name": "Anton",
        "file": "https://fonts.gstatic.com/s/anton/v25/1Ptgg87LROyAm0K08i4gS7lu.ttf"
      },
      {
        "name": "Noticia Text",
        "file": "https://fonts.gstatic.com/s/noticiatext/v15/VuJ2dNDF2Yv9qppOePKYRP1GYTFZt0rNpQ.ttf"
      },
      {
        "name": "Hind",
        "file": "https://fonts.gstatic.com/s/hind/v16/5aU69_a8oxmIRG5yBROzkDM.ttf"
      },
      {
        "name": "Asap",
        "file": "https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYkqUsLmOXoA7Glw.ttf"
      },
      {
        "name": "Maven Pro",
        "file": "https://fonts.gstatic.com/s/mavenpro/v33/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8SX25nCpozp5GvU.ttf"
      },
      {
        "name": "Barlow Condensed",
        "file": "https://fonts.gstatic.com/s/barlowcondensed/v12/HTx3L3I-JCGChYJ8VI-L6OO_au7B2xbZ23n3pKg.ttf"
      },
      {
        "name": "Comfortaa",
        "file": "https://fonts.gstatic.com/s/comfortaa/v45/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4WjMPrQVIT9c2c8.ttf"
      },
      {
        "name": "Noto Sans SC",
        "file": "https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG9_FnYxNbPzS5HE.ttf"
      },
      {
        "name": "Rajdhani",
        "file": "https://fonts.gstatic.com/s/rajdhani/v15/LDIxapCSOBg7S-QT7q4AOeekWPrP.ttf"
      },
      {
        "name": "Plus Jakarta Sans",
        "file": "https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_qU7NShXUEKi4Rw.ttf"
      },
      {
        "name": "Abel",
        "file": "https://fonts.gstatic.com/s/abel/v18/MwQ5bhbm2POE6VhLPJp6qGI.ttf"
      },
      {
        "name": "Figtree",
        "file": "https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_d_QF5ewkEU4HTy.ttf"
      },
      {
        "name": "Sora",
        "file": "https://fonts.gstatic.com/s/sora/v12/xMQOuFFYT72X5wkB_18qmnndmSdSnn-KIwNhBti0.ttf"
      },
      {
        "name": "Zilla Slab",
        "file": "https://fonts.gstatic.com/s/zillaslab/v11/dFa6ZfeM_74wlPZtksIFWj0w_HyIRlE.ttf"
      },
      {
        "name": "Asap Condensed",
        "file": "https://fonts.gstatic.com/s/asapcondensed/v17/pxidypY1o9NHyXh3WvSbGSggdNeLYk1Mq3ap.ttf"
      },
      {
        "name": "Questrial",
        "file": "https://fonts.gstatic.com/s/questrial/v18/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf"
      },
      {
        "name": "Pridi",
        "file": "https://fonts.gstatic.com/s/pridi/v13/2sDQZG5JnZLfkfWao2krbl29.ttf"
      },
      {
        "name": "Exo 2",
        "file": "https://fonts.gstatic.com/s/exo2/v21/7cH1v4okm5zmbvwkAx_sfcEuiD8jvvKcPtq-rpvLpQ.ttf"
      },
      {
        "name": "Teko",
        "file": "https://fonts.gstatic.com/s/teko/v20/LYjYdG7kmE0gV69VVPPdFl06VN8XG7Sy3TKEvkCF.ttf"
      },
      {
        "name": "Lobster",
        "file": "https://fonts.gstatic.com/s/lobster/v30/neILzCirqoswsqX9_oWsMqEzSJQ.ttf"
      },
      {
        "name": "Slabo 27px",
        "file": "https://fonts.gstatic.com/s/slabo27px/v14/mFT0WbgBwKPR_Z4hGN2qsxgJ1EJ7i90.ttf"
      },
      {
        "name": "Outfit",
        "file": "https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4TC1C4G-EiAou6Y.ttf"
      },
      {
        "name": "Abril Fatface",
        "file": "https://fonts.gstatic.com/s/abrilfatface/v23/zOL64pLDlL1D99S8g8PtiKchm-BsjOLhZBY.ttf"
      },
      {
        "name": "Assistant",
        "file": "https://fonts.gstatic.com/s/assistant/v19/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtuZnEGGf3qGuvM4.ttf"
      },
      {
        "name": "Noto Kufi Arabic",
        "file": "https://fonts.gstatic.com/s/notokufiarabic/v21/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh5v34bPnLSmf5yD.ttf"
      },
      {
        "name": "Signika Negative",
        "file": "https://fonts.gstatic.com/s/signikanegative/v21/E21x_cfngu7HiRpPX3ZpNE4kY5zKSPmJXkF0VDD2RAqnS73st9hiuEq8.ttf"
      },
      {
        "name": "PT Sans Narrow",
        "file": "https://fonts.gstatic.com/s/ptsansnarrow/v18/BngRUXNadjH0qYEzV7ab-oWlsYCByxyKeuDp.ttf"
      },
      {
        "name": "Crimson Text",
        "file": "https://fonts.gstatic.com/s/crimsontext/v19/wlp2gwHKFkZgtmSR3NB0oRJvaAJSA_JN3Q.ttf"
      },

      {
        "name": "DM Serif Display",
        "file": "https://fonts.gstatic.com/s/dmserifdisplay/v15/-nFnOHM81r4j6k0gjAW3mujVU2B2K_d709jy92k.ttf"
      },
      {
        "name": "Urbanist",
        "file": "https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDyx4fFpOrS8SlKw.ttf"
      },
      {
        "name": "Red Hat Display",
        "file": "https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbmyWckg5-Xecg3w.ttf"
      },
      {
        "name": "Cormorant Garamond",
        "file": "https://fonts.gstatic.com/s/cormorantgaramond/v16/co3bmX5slCNuHLi8bLeY9MK7whWMhyjornFLsS6V7w.ttf"
      },
      {
        "name": "IBM Plex Mono",
        "file": "https://fonts.gstatic.com/s/ibmplexmono/v19/-F63fjptAgt5VM-kVkqdyU8n5igg1l9kn-s.ttf"
      },
      {
        "name": "Source Sans 3",
        "file": "https://fonts.gstatic.com/s/sourcesans3/v15/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Ky461EN_io6npfB.ttf"
      },
      {
        "name": "Satisfy",
        "file": "https://fonts.gstatic.com/s/satisfy/v21/rP2Hp2yn6lkG50LoOZSCHBeHFl0.ttf"
      },
      {
        "name": "Public Sans",
        "file": "https://fonts.gstatic.com/s/publicsans/v15/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuFpm5ww0pX189fg.ttf"
      },
      {
        "name": "Fjalla One",
        "file": "https://fonts.gstatic.com/s/fjallaone/v15/Yq6R-LCAWCX3-6Ky7FAFnOZwkxgtUb8.ttf"
      },
      {
        "name": "Arvo",
        "file": "https://fonts.gstatic.com/s/arvo/v22/tDbD2oWUg0MKmSAa7Lzr7vs.ttf"
      },
      {
        "name": "Lexend",
        "file": "https://fonts.gstatic.com/s/lexend/v19/wlptgwvFAVdoq2_F94zlCfv0bz1WCzsW_LBte6KuGEo.ttf"
      },
      {
        "name": "Fira Sans Condensed",
        "file": "https://fonts.gstatic.com/s/firasanscondensed/v10/wEOhEADFm8hSaQTFG18FErVhsC9x-tarYfHnrMtVbx8.ttf"
      },
      {
        "name": "Noto Serif JP",
        "file": "https://fonts.gstatic.com/s/notoserifjp/v21/xn7mYHs72GKoTvER4Gn3b5eMXNikYkY0T84.otf"
      },
      {
        "name": "Nanum Gothic",
        "file": "https://fonts.gstatic.com/s/nanumgothic/v23/PN_3Rfi-oW3hYwmKDpxS7F_z_tLfxno73g.ttf"
      },
      {
        "name": "Signika",
        "file": "https://fonts.gstatic.com/s/signika/v25/vEF72_JTCgwQ5ejvMV0Ox_Kg1UwJ0tKfX4zNpD8E4ASzH1r9gTuYzTMngt4xjw.ttf"
      },
      {
        "name": "Changa",
        "file": "https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZ62xQjDp9htf1ZM.ttf"
      },
      {
        "name": "Lilita One",
        "file": "https://fonts.gstatic.com/s/lilitaone/v15/i7dPIFZ9Zz-WBtRtedDbUEZ2RFq7AwU.ttf"
      },
      {
        "name": "Prompt",
        "file": "https://fonts.gstatic.com/s/prompt/v10/-W__XJnvUD7dzB26Z9AcZkIzeg.ttf"
      },
      {
        "name": "Barlow Semi Condensed",
        "file": "https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpvgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRnf4CrCEo4gg.ttf"
      },
      {
        "name": "Play",
        "file": "https://fonts.gstatic.com/s/play/v19/6aez4K2oVqwIjtI8Hp8Tx3A.ttf"
      },

      {
        "name": "Domine",
        "file": "https://fonts.gstatic.com/s/domine/v20/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X3LAI10VErGuW8Q.ttf"
      },
      {
        "name": "Noto Serif TC",
        "file": "https://fonts.gstatic.com/s/notoseriftc/v23/XLYgIZb5bJNDGYxLBibeHZ0BhnEESXFtUsM.otf"
      },
      {
        "name": "Archivo Black",
        "file": "https://fonts.gstatic.com/s/archivoblack/v21/HTxqL289NzCGg4MzN6KJ7eW6OYuP_x7yx3A.ttf"
      },
      {
        "name": "Merriweather Sans",
        "file": "https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZou4ljuEG7xFHnQ.ttf"
      },
      {
        "name": "Titan One",
        "file": "https://fonts.gstatic.com/s/titanone/v15/mFTzWbsGxbbS_J5cQcjykzIn2Etikg.ttf"
      },
      {
        "name": "Source Serif 4",
        "file": "https://fonts.gstatic.com/s/sourceserif4/v8/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjihdqrhxXD-wGvjU.ttf"
      },
      {
        "name": "Archivo Narrow",
        "file": "https://fonts.gstatic.com/s/archivonarrow/v30/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhvLFGKpHOtFCQ76Q.ttf"
      },
      {
        "name": "Kalam",
        "file": "https://fonts.gstatic.com/s/kalam/v16/YA9dr0Wd4kDdMuhWMibDszkB.ttf"
      },
      {
        "name": "Noto Sans Display",
        "file": "https://fonts.gstatic.com/s/notosansdisplay/v26/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_3cKVTGQ2iHrvWM.ttf"
      },
      {
        "name": "Catamaran",
        "file": "https://fonts.gstatic.com/s/catamaran/v19/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPHjd1anXuluiLyw.ttf"
      },
      {
        "name": "Indie Flower",
        "file": "https://fonts.gstatic.com/s/indieflower/v21/m8JVjfNVeKWVnh3QMuKkFcZlbkGG1dKEDw.ttf"
      },
      {
        "name": "Chakra Petch",
        "file": "https://fonts.gstatic.com/s/chakrapetch/v11/cIf6MapbsEk7TDLdtEz1BwkmmKBhSL7Y1Q.ttf"
      },
      {
        "name": "Macondo",
        "file": "https://fonts.gstatic.com/s/macondo/v25/RrQQboN9-iB1IXmOS2XO0LBBd4Y.ttf"
      },

      {
        "name": "Permanent Marker",
        "file": "https://fonts.gstatic.com/s/permanentmarker/v16/Fh4uPib9Iyv2ucM6pGQMWimMp004HaqIfrT5nlk.ttf"
      },
      {
        "name": "Orbitron",
        "file": "https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyGy6xpmIyXjU1pg.ttf"
      },
      {
        "name": "Bree Serif",
        "file": "https://fonts.gstatic.com/s/breeserif/v17/4UaHrEJCrhhnVA3DgluAx63j5pN1MwI.ttf"
      },
      {
        "name": "Space Mono",
        "file": "https://fonts.gstatic.com/s/spacemono/v13/i7dPIFZifjKcF5UAWdDRUEZ2RFq7AwU.ttf"
      },
      {
        "name": "Amiri",
        "file": "https://fonts.gstatic.com/s/amiri/v27/J7aRnpd8CGxBHqUpvrIw74NL.ttf"
      },
      {
        "name": "Readex Pro",
        "file": "https://fonts.gstatic.com/s/readexpro/v21/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTC4USmgmsglvjkag.ttf"
      },
      {
        "name": "IBM Plex Serif",
        "file": "https://fonts.gstatic.com/s/ibmplexserif/v19/jizDREVNn1dOx-zrZ2X3pZvkThUY0TY7ikbI.ttf"
      },
      {
        "name": "Handlee",
        "file": "https://fonts.gstatic.com/s/handlee/v18/-F6xfjBsISg9aMakDmr6oilJ3ik.ttf"
      },
      {
        "name": "Eczar",
        "file": "https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXHd6WqTIVKWJKWg.ttf"
      },
      {
        "name": "Noto Sans HK",
        "file": "https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qHB--oWTiYjNvVA.ttf"
      },
      {
        "name": "Alegreya Sans",
        "file": "https://fonts.gstatic.com/s/alegreyasans/v24/5aUz9_-1phKLFgshYDvh6Vwt3V1nvEVXlm4.ttf"
      },
      {
        "name": "Roboto Flex",
        "file": "https://fonts.gstatic.com/s/robotoflex/v26/NaNnepOXO_NexZs0b5QrzlOHb8wCikXpYqmZsWI-__OGbt8jZktqc2V3Zs0KvDLdBP8SBZtOs2IifRuUZQMsPJtUsR4DEK6cULNeUx9XgTnH37Ha_FIAp4Fm0PP1hw45DntW2x0wZGzhPmr1YNMYKYn9_1IQXGwJAiUJVUMdN5YUW4O8HtSoXjC1z3QSabshNFVe3e0O5j3ZjrZCu23Qd4G0EBysQNK-QKavMl1cKq3tHXtXi8mzLjaAQbGunCNCKMY.ttf"
      },
      {
        "name": "Montserrat Alternates",
        "file": "https://fonts.gstatic.com/s/montserratalternates/v17/mFTvWacfw6zH4dthXcyms1lPpC8I_b0juU0J7K3RCJ1b0w.ttf"
      },
      {
        "name": "Righteous",
        "file": "https://fonts.gstatic.com/s/righteous/v17/1cXxaUPXBpj2rGoU7C9mj3uEicG01A.ttf"
      },
      {
        "name": "Creepster",
        "file": "https://fonts.gstatic.com/s/creepster/v13/AlZy_zVUqJz4yMrniH4hdXf4XB0Tow.ttf"
      },
      {
        "name": "Great Vibes",
        "file": "https://fonts.gstatic.com/s/greatvibes/v18/RWmMoKWR9v4ksMfaWd_JN-XCg6UKDXlq.ttf"
      },
      {
        "name": "Patua One",
        "file": "https://fonts.gstatic.com/s/patuaone/v20/ZXuke1cDvLCKLDcimxBI5PNvNA9LuA.ttf"
      },
      {
        "name": "Rowdies",
        "file": "https://fonts.gstatic.com/s/rowdies/v17/ptRJTieMYPNBAK21zrdJwObZNQo.ttf"
      },
      {
        "name": "Tinos",
        "file": "https://fonts.gstatic.com/s/tinos/v24/buE4poGnedXvwgX8dGVh8TI-.ttf"
      },
      {
        "name": "Cinzel",
        "file": "https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-tbnTYrvDE5ZdqU.ttf"
      },
      {
        "name": "Alata",
        "file": "https://fonts.gstatic.com/s/alata/v9/PbytFmztEwbIofe6xKcRQEOX.ttf"
      },
      {
        "name": "Mukta",
        "file": "https://fonts.gstatic.com/s/mukta/v14/iJWKBXyXfDDVXYnGp32S0H3f.ttf"
      },
      {
        "name": "Chivo",
        "file": "https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_vB_ul2DSFXjQiQ.ttf"
      },
      {
        "name": "Acme",
        "file": "https://fonts.gstatic.com/s/acme/v25/RrQfboBx-C5_bx3Lb23lzLk.ttf"
      },
      {
        "name": "Roboto Serif",
        "file": "https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEliotp6d2Af5fR4k.ttf"
      },
      {
        "name": "Kaushan Script",
        "file": "https://fonts.gstatic.com/s/kaushanscript/v16/vm8vdRfvXFLG3OLnsO15WYS5DF7_ytN3M48a.ttf"
      },
      {
        "name": "Frank Ruhl Libre",
        "file": "https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw7FYVqQPxR2EUR_.ttf"
      },
      {
        "name": "Yanone Kaffeesatz",
        "file": "https://fonts.gstatic.com/s/yanonekaffeesatz/v30/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIfto9tWpcGuLCnXkVA.ttf"
      },
      {
        "name": "Cormorant",
        "file": "https://fonts.gstatic.com/s/cormorant/v21/H4c2BXOCl9bbnla_nHIA47NMUjsNbCVrFhFTQ7Rg7A2uwYs.ttf"
      },
      {
        "name": "Vollkorn",
        "file": "https://fonts.gstatic.com/s/vollkorn/v23/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2MHGuGWOdEbD63w.ttf"
      },
      {
        "name": "Didact Gothic",
        "file": "https://fonts.gstatic.com/s/didactgothic/v20/ahcfv8qz1zt6hCC5G4F_P4ASpUySp0LlcyQ.ttf"
      },
      {
        "name": "Noto Naskh Arabic",
        "file": "https://fonts.gstatic.com/s/notonaskharabic/v33/RrQ5bpV-9Dd1b1OAGA6M9PkyDuVBePeKNaxcsss0Y7bwvc5krK0z9_Mnuw.ttf"
      },
      {
        "name": "Exo",
        "file": "https://fonts.gstatic.com/s/exo/v21/4UaZrEtFpBI4f1ZSIK9d4LjJ4lM3CwNsOl4p5Is.ttf"
      },
      {
        "name": "Amatic SC",
        "file": "https://fonts.gstatic.com/s/amaticsc/v26/TUZyzwprpvBS1izr_vO0De6ecZQf1A.ttf"
      },
      {
        "name": "Patrick Hand",
        "file": "https://fonts.gstatic.com/s/patrickhand/v23/LDI1apSQOAYtSuYWp8ZhfYeMWcjKm7sp8g.ttf"
      },
      {
        "name": "Courgette",
        "file": "https://fonts.gstatic.com/s/courgette/v17/wEO_EBrAnc9BLjLQAUkFUfAL3EsHiA.ttf"
      },
      {
        "name": "Saira",
        "file": "https://fonts.gstatic.com/s/saira/v20/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA71rCosg7lwYmUVY.ttf"
      },
      {
        "name": "Noto Sans Mono",
        "file": "https://fonts.gstatic.com/s/notosansmono/v30/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_FNJ49rXVEQQL8Y.ttf"
      },
      {
        "name": "M PLUS Rounded 1c",
        "file": "https://fonts.gstatic.com/s/mplusrounded1c/v15/VdGEAYIAV6gnpUpoWwNkYvrugw9RuPWGzr8C7vav.ttf"
      },
      {
        "name": "Alegreya Sans SC",
        "file": "https://fonts.gstatic.com/s/alegreyasanssc/v23/mtGh4-RGJqfMvt7P8FUr0Q1j-Hf1Nk5v9ixALYs.ttf"
      },
      {
        "name": "Albert Sans",
        "file": "https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHq5P_rI32TxAj1g.ttf"
      },
      {
        "name": "Alfa Slab One",
        "file": "https://fonts.gstatic.com/s/alfaslabone/v19/6NUQ8FmMKwSEKjnm5-4v-4Jh6dVretWvYmE.ttf"
      },
      {
        "name": "Philosopher",
        "file": "https://fonts.gstatic.com/s/philosopher/v19/vEFV2_5QCwIS4_Dhez5jcVBpRUwU08qe.ttf"
      },
      {
        "name": "El Messiri",
        "file": "https://fonts.gstatic.com/s/elmessiri/v22/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuXwe65ghj3OoapG.ttf"
      },
      {
        "name": "Spectral",
        "file": "https://fonts.gstatic.com/s/spectral/v13/rnCr-xNNww_2s0amA-M-mHnOSOuk.ttf"
      },
      {
        "name": "Passion One",
        "file": "https://fonts.gstatic.com/s/passionone/v18/PbynFmL8HhTPqbjUzux3JHuW_Frg6YoV.ttf"
      },
      {
        "name": "Marcellus",
        "file": "https://fonts.gstatic.com/s/marcellus/v13/wEO_EBrOk8hQLDvIAF8FUfAL3EsHiA.ttf"
      },
      {
        "name": "Alegreya",
        "file": "https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNG9hUI_KCisSGVrw.ttf"
      },
      {
        "name": "Neuton",
        "file": "https://fonts.gstatic.com/s/neuton/v22/UMBTrPtMoH62xUZyyII7civlBw.ttf"
      },
      {
        "name": "Crimson Pro",
        "file": "https://fonts.gstatic.com/s/crimsonpro/v24/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZzm18OJE_VNWoyQ.ttf"
      },
      {
        "name": "Russo One",
        "file": "https://fonts.gstatic.com/s/russoone/v16/Z9XUDmZRWg6M1LvRYsH-yMOInrib9Q.ttf"
      },
      {
        "name": "Libre Barcode 39",
        "file": "https://fonts.gstatic.com/s/librebarcode39/v21/-nFnOHM08vwC6h8Li1eQnP_AHzI2K_d709jy92k.ttf"
      },
      {
        "name": "Lobster Two",
        "file": "https://fonts.gstatic.com/s/lobstertwo/v20/BngMUXZGTXPUvIoyV6yN59fK7KSJ4ACD.ttf"
      },
      {
        "name": "Hind Siliguri",
        "file": "https://fonts.gstatic.com/s/hindsiliguri/v12/ijwTs5juQtsyLLR5jN4cxBEofJvQxuk0Nig.ttf"
      },
      {
        "name": "Lexend Deca",
        "file": "https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U48M1ArBPCqLNflg.ttf"
      },
      {
        "name": "Gloria Hallelujah",
        "file": "https://fonts.gstatic.com/s/gloriahallelujah/v21/LYjYdHv3kUk9BMV96EIswT9DIbW-MLSy3TKEvkCF.ttf"
      },
      {
        "name": "Old Standard TT",
        "file": "https://fonts.gstatic.com/s/oldstandardtt/v20/MwQubh3o1vLImiwAVvYawgcf2eVurVC5RHdCZg.ttf"
      },
      {
        "name": "Saira Condensed",
        "file": "https://fonts.gstatic.com/s/sairacondensed/v11/EJROQgErUN8XuHNEtX81i9TmEkrfpeFE-IyCrw.ttf"
      },
      {
        "name": "Prata",
        "file": "https://fonts.gstatic.com/s/prata/v20/6xKhdSpbNNCT-vWIAG_5LWwJ.ttf"
      },
      {
        "name": "Sarabun",
        "file": "https://fonts.gstatic.com/s/sarabun/v15/DtVjJx26TKEr37c9WBJDnlQN9gk.ttf"
      },
      {
        "name": "Encode Sans",
        "file": "https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGGHjZtWP7FJCt2c.ttf"
      },
      {
        "name": "ABeeZee",
        "file": "https://fonts.gstatic.com/s/abeezee/v22/esDR31xSG-6AGleN6tKukbcHCpE.ttf"
      },
      {
        "name": "League Spartan",
        "file": "https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvM_oTpBMdcFguczA.ttf"
      },
      {
        "name": "Bowlby One",
        "file": "https://fonts.gstatic.com/s/bowlbyone/v23/taiPGmVuC4y96PFeqp8smo6C_Z0wcK4.ttf"
      },
      {
        "name": "Palanquin",
        "file": "https://fonts.gstatic.com/s/palanquin/v13/9XUnlJ90n1fBFg7ceXwsdlFMzLC2Zw.ttf"
      },
      {
        "name": "DM Serif Text",
        "file": "https://fonts.gstatic.com/s/dmseriftext/v12/rnCu-xZa_krGokauCeNq1wWyafOPXHIJErY.ttf"
      },
      {
        "name": "Baloo Bhaijaan 2",
        "file": "https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TyRSqP4L4ppfcyC.ttf"
      },
      {
        "name": "Francois One",
        "file": "https://fonts.gstatic.com/s/francoisone/v21/_Xmr-H4zszafZw3A-KPSZutNxgKQu_avAg.ttf"
      },
      {
        "name": "Reem Kufi",
        "file": "https://fonts.gstatic.com/s/reemkufi/v21/2sDPZGJLip7W2J7v7wQZZE1I0yCmYzzQtuZnEGGf3qGuvM4.ttf"
      },
      {
        "name": "Ubuntu Condensed",
        "file": "https://fonts.gstatic.com/s/ubuntucondensed/v16/u-4k0rCzjgs5J7oXnJcM_0kACGMtf-fVqvHoJXw.ttf"
      },
      {
        "name": "Merienda",
        "file": "https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5enhoSU78QGBV0A.ttf"
      },
      {
        "name": "Viga",
        "file": "https://fonts.gstatic.com/s/viga/v14/xMQbuFFdSaiX_QIjD4e2OX8.ttf"
      },
      {
        "name": "STIX Two Text",
        "file": "https://fonts.gstatic.com/s/stixtwotext/v12/YA9Gr02F12Xkf5whdwKf11l0jbKkeidMTtZ5Yihg2SOYWxFMN1WD.ttf"
      },
      {
        "name": "Yeseva One",
        "file": "https://fonts.gstatic.com/s/yesevaone/v22/OpNJno4ck8vc-xYpwWWxpipfWhXD00c.ttf"
      },
      {
        "name": "Lalezar",
        "file": "https://fonts.gstatic.com/s/lalezar/v14/zrfl0HLVx-HwTP82UaDyIiL0RCg.ttf"
      },
      {
        "name": "Noto Sans Thai",
        "file": "https://fonts.gstatic.com/s/notosansthai/v25/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU5RtpzF-QRvzzXg.ttf"
      },
      {
        "name": "PT Sans Caption",
        "file": "https://fonts.gstatic.com/s/ptsanscaption/v19/0FlMVP6Hrxmt7-fsUFhlFXNIlpcqfQXwQy6yxg.ttf"
      },
      {
        "name": "Cardo",
        "file": "https://fonts.gstatic.com/s/cardo/v19/wlp_gwjKBV1pqiv_1oAZ2H5O.ttf"
      },
      {
        "name": "Black Ops One",
        "file": "https://fonts.gstatic.com/s/blackopsone/v20/qWcsB6-ypo7xBdr6Xshe96H3WDzRtjkho4M.ttf"
      },
      {
        "name": "Mada",
        "file": "https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFnOkHkw2-m9x2iC.ttf"
      },
      {
        "name": "Bungee",
        "file": "https://fonts.gstatic.com/s/bungee/v13/N0bU2SZBIuF2PU_ECn50Kd_PmA.ttf"
      },
      {
        "name": "Sofia",
        "file": "https://fonts.gstatic.com/s/sofia/v14/8QIHdirahM3j_vu-sowsrqjk.ttf"
      },
      {
        "name": "Fira Code",
        "file": "https://fonts.gstatic.com/s/firacode/v22/uU9eCBsR6Z2vfE9aq3bL0fxyUs4tcw4W_D1sFVfxN87gsj0.ttf"
      },
      {
        "name": "Sacramento",
        "file": "https://fonts.gstatic.com/s/sacramento/v15/buEzpo6gcdjy0EiZMBUG0CoV_NxLeiw.ttf"
      },
      {
        "name": "Underdog",
        "file": "https://fonts.gstatic.com/s/underdog/v23/CHygV-jCElj7diMroVSiU14GN2Il.ttf"
      },
      {
        "name": "Josefin Slab",
        "file": "https://fonts.gstatic.com/s/josefinslab/v26/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W71msd3k3K6CcEyI.ttf"
      },
      {
        "name": "Kumbh Sans",
        "file": "https://fonts.gstatic.com/s/kumbhsans/v22/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQkZYA8bTuUkqaLg.ttf"
      },
      {
        "name": "Yantramanav",
        "file": "https://fonts.gstatic.com/s/yantramanav/v13/flU8Rqu5zY00QEpyWJYWN6f0V-dRCQ41.ttf"
      },
      {
        "name": "Fira Sans Extra Condensed",
        "file": "https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPKcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda5fiku3efvE8.ttf"
      },
      {
        "name": "Crete Round",
        "file": "https://fonts.gstatic.com/s/creteround/v14/55xoey1sJNPjPiv1ZZZrxJ1827zAKnxN.ttf"
      },
      {
        "name": "Cantarell",
        "file": "https://fonts.gstatic.com/s/cantarell/v17/B50NF7ZDq37KMUvlO01Ji6hqHK-CLA.ttf"
      },
      {
        "name": "Abhaya Libre",
        "file": "https://fonts.gstatic.com/s/abhayalibre/v17/e3tmeuGtX-Co5MNzeAOqinEge0PWovdU4w.ttf"
      },
      {
        "name": "Yellowtail",
        "file": "https://fonts.gstatic.com/s/yellowtail/v22/OZpGg_pnoDtINPfRIlLotlzNwED-b4g.ttf"
      },
      {
        "name": "Luckiest Guy",
        "file": "https://fonts.gstatic.com/s/luckiestguy/v22/_gP_1RrxsjcxVyin9l9n_j2RStR3qDpraA.ttf"
      },


    ]
  constructor(
    private firestore: AngularFirestore,
    private authService: AuthService,
    private registryService: RegistryService,
    private registryFirebaseService: RegistryFirebaseService,
    private afs: AngularFirestore,
    private settingsStateStore: SettingsStateStore,
    private imageUrlService: ImageUrlService
  ) {
    this.state$ = new BehaviorSubject<State>({
      website: new Website(),
      user: null,
      groupedScheduleItems: [],
      customFonts: [],
      settings: null
    });

    this.settingsStateStore.getState().subscribe(state => {
      this.settings = state.settings;
    })

    this.authService.user.subscribe(user => {

      if (user) {
        this.userId = user.uid;
        this.user = user;
        this.fetchWebsiteData();
      }
    });











  }

  killLoader() {
    const loader = document.getElementById('reg-loader');
    if (loader) {
      loader.remove(); //
    }
  }


  getWebsite(): Website {
    return this.state$.getValue().website;
  }
  setRegistryLinkLogos(website: Website): Website {
    if (website.registry && website.registry.registryItems) {
      website.registry.registryItems.forEach(registryItem => {


        const url = registryItem.url.toLowerCase();
        const name = registryItem.name.toLowerCase();

        if (url.includes('target') || name.includes('target')) {
          registryItem.logo = 'target';
        }

        else if (url.includes('amazon') || name.includes('amazon')) {
          registryItem.logo = 'amazon';
        }
        else if (url.includes('crateandbarrel') || name.includes('crateandbarrel') ||
          (name.includes('crate') && name.includes('barrel'))) {
          registryItem.logo = 'crateandbarrel';

        }

        //else return a version of the domain name without any spcial chars or spaces or . 
        else if (url) {
          const domainMatch = url.match(/:\/\/(www\.)?(.[^/]+)/);
          if (domainMatch && domainMatch[2]) {
            const domain = domainMatch[2];
            const domainParts = domain.split('.');
            if (domainParts.length >= 2) {
              const mainDomain = domainParts.slice(-2, -1)[0];
              registryItem.logo = mainDomain.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
            }
          }
        } else if (name) {
          registryItem.logo = name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
        }

      });
    }
    return website;
  }

  getWebsiteByName(siteName: string): Observable<Website> {
    return this.afs.collection<Registry>('registries', ref =>
      ref.where('registryName', '==', siteName)
    ).snapshotChanges().pipe(
      switchMap(registrySnapshots => {
        if (registrySnapshots && registrySnapshots.length > 0 && registrySnapshots[0].payload) {
          let registry = registrySnapshots[0].payload.doc.data() as Registry;
          registry.id = registrySnapshots[0].payload.doc.id;

          return this.afs.collection<Website>(this.FIRESTORE_WEBSITES_DOCUMENT_COLLECTION_NAME, ref =>
            ref.where('userId', '==', registry.userId)
          ).snapshotChanges().pipe(
            switchMap(websiteSnapshots => {
              if (websiteSnapshots && websiteSnapshots.length > 0 && websiteSnapshots[0].payload) {
                let website = websiteSnapshots[0].payload.doc.data() as Website;
                website.id = websiteSnapshots[0].payload.doc.id;
                website = this.setRegistryLinkLogos(website);
                this.sortWeddingEventsByDateIfExists(website);
                this.fixDates(website, registry);
                this.setDefaultRegistryButtonText(website);
                website = this.processWebsiteImageUrls(website);
                return this.afs.collection<Settings>(this.WEBSITES_SETTINGS_COLLECTION_NAME, ref =>
                  ref.where('userId', '==', website.userId)
                ).snapshotChanges().pipe(
                  map(settingsSnapshots => {
                    let settings = null;
                    if (settingsSnapshots && settingsSnapshots.length > 0) {
                      settings = settingsSnapshots[0].payload.doc.data() as Settings;
                      settings.id = settingsSnapshots[0].payload.doc.id;
                    }

                    this.updateState({
                      website: website,
                      user: null,
                      groupedScheduleItems: this.initScheduleList(website),
                      customFonts: this.processFonts(website),
                      settings: settings
                    });
                    this.killLoader();
                    return website;
                  })
                );
              }
              return Observable.of(null);
            })
          );
        }
        return Observable.of(null);
      })
    );
  }

  setDefaultRegistryButtonText(website: Website) {
    if (!website) {
      return;
    }

    if (!website.registry) {
      website.registry = {
        registryItems: [],
        isLinkedtoHitchd: false,
        isEnabled: false,
        sectionName: '',
        leadInText: '',
        leadInTextTranslation: '',
        buttonText: '',
        buttonTextTranslation: '',
        sectionNameTranslation: ''
      };
    }

    const defaultText = 'Honeymoon Registry';

    if (!website.registry.buttonText || website.registry.buttonText.trim() === '') {
      website.registry.buttonText = defaultText;
    }

    if (!website.registry.buttonTextTranslation || website.registry.buttonTextTranslation.trim() === '') {
      website.registry.buttonTextTranslation = defaultText;
    }
  }

  // Utility method to create timezone-safe dates from UTC components
  private createDateFromUtc(utcComponents: { year: number, month: number, day: number }): Date {
    // Validate inputs for production safety
    if (!Number.isInteger(utcComponents.year) || utcComponents.year < 1900 || utcComponents.year > 3000) {
      throw new Error(`Invalid year: ${utcComponents.year}`);
    }
    if (!Number.isInteger(utcComponents.month) || utcComponents.month < 0 || utcComponents.month > 11) {
      throw new Error(`Invalid month: ${utcComponents.month}`);
    }
    if (!Number.isInteger(utcComponents.day) || utcComponents.day < 1 || utcComponents.day > 31) {
      throw new Error(`Invalid day: ${utcComponents.day}`);
    }

    // Create date at noon local time to preserve date components across all timezones
    return new Date(utcComponents.year, utcComponents.month, utcComponents.day, 12, 0, 0);
  }

  fixDates(website: Website, registry: Registry) {
    if (!registry) return;
    if (!website) return;

    for (let event of website.weddingEvents) {
      if (event.startDate && !event.startDateUtc) {
        event.startDate = this.formatDateForCountry(event.startDate.toISOString(), registry.country)
        event.startDateUtc = this.preserveDateOnly(event.startDate);
      } else if (event.startDateUtc &&
        typeof event.startDateUtc.year === 'number' &&
        typeof event.startDateUtc.month === 'number' &&
        typeof event.startDateUtc.day === 'number') {
        event.startDate = this.createDateFromUtc(event.startDateUtc);
      }
      if (event.endDate && !event.endDateUtc) {
        event.endDate = this.formatDateForCountry(event.endDate.toISOString(), registry.country)
        event.endDateUtc = this.preserveDateOnly(event.endDate);
      } else if (event.endDateUtc &&
        typeof event.endDateUtc.year === 'number' &&
        typeof event.endDateUtc.month === 'number' &&
        typeof event.endDateUtc.day === 'number') {
        event.endDate = this.createDateFromUtc(event.endDateUtc);
      }
    }

    if (website.schedule && website.schedule.scheduleItems) {
      for (let item of website.schedule.scheduleItems) {
        if (item.startDate && !item.startDateUtc) {
          item.startDate = this.formatDateForCountry(item.startDate.toISOString(), registry.country)
          item.startDateUtc = this.preserveDateOnly(item.startDate);
        } else if (item.startDateUtc &&
          typeof item.startDateUtc.year === 'number' &&
          typeof item.startDateUtc.month === 'number' &&
          typeof item.startDateUtc.day === 'number') {
          item.startDate = this.createDateFromUtc(item.startDateUtc);
        }
        if (item.endDate && !item.endDateUtc) {
          item.endDate = this.formatDateForCountry(item.endDate.toISOString(), registry.country)
          item.endDateUtc = this.preserveDateOnly(item.endDate);
        } else if (item.endDateUtc &&
          typeof item.endDateUtc.year === 'number' &&
          typeof item.endDateUtc.month === 'number' &&
          typeof item.endDateUtc.day === 'number') {
          item.endDate = this.createDateFromUtc(item.endDateUtc);
        }
      }
    }

    if (website.welcome.eventDate && !website.welcome.eventDateUtc) {
      website.welcome.eventDate = this.formatDateForCountry(website.welcome.eventDate.toISOString(), registry.country)
      website.welcome.eventDateUtc = this.preserveDateOnly(website.welcome.eventDate);
    } else if (website.welcome.eventDateUtc &&
      typeof website.welcome.eventDateUtc.year === 'number' &&
      typeof website.welcome.eventDateUtc.month === 'number' &&
      typeof website.welcome.eventDateUtc.day === 'number') {
      website.welcome.eventDate = this.createDateFromUtc(website.welcome.eventDateUtc);
    }

    if (website.welcome.rsvpDeadline && !website.welcome.rsvpDeadlineDateUtc) {
      website.welcome.rsvpDeadline = this.formatDateForCountry(website.welcome.rsvpDeadline.toISOString(), registry.country)
      website.welcome.rsvpDeadlineDateUtc = this.preserveDateOnly(website.welcome.rsvpDeadline);
    } else if (website.welcome.rsvpDeadlineDateUtc &&
      typeof website.welcome.rsvpDeadlineDateUtc.year === 'number' &&
      typeof website.welcome.rsvpDeadlineDateUtc.month === 'number' &&
      typeof website.welcome.rsvpDeadlineDateUtc.day === 'number') {
      website.welcome.rsvpDeadline = this.createDateFromUtc(website.welcome.rsvpDeadlineDateUtc);
    }
  }
  fetchWebsiteData() {
    this.userId = this.user && this.user.userId ? this.user.userId :
      (this.settings && this.settings.userId ? this.settings.userId : null);

    if (!this.userId) {
      throw new Error('no user ID supplied: Hitchd crash error');
    }

    this.afs
      .collection<Website>(this.FIRESTORE_WEBSITES_DOCUMENT_COLLECTION_NAME, ref =>
        ref.where('userId', '==', this.userId)
      )
      .snapshotChanges()
      .pipe(
        switchMap(x => {
          if (x && x.length > 0 && x[0].payload) {
            let website = x[0].payload.doc.data() as Website;
            website.id = x[0].payload.doc.id;
            website = this.setRegistryLinkLogos(website);
            this.fixDatesAndRegistry(website);
            this.sortWeddingEventsByDateIfExists(website);
            this.setDefaultRegistryButtonText(website);
            website = this.processWebsiteImageUrls(website);

            if (!website.style) {
              website.style = 'minimal';
            }

            return this.afs.collection<Settings>(this.WEBSITES_SETTINGS_COLLECTION_NAME, ref =>
              ref.where('userId', '==', website.userId)
            ).snapshotChanges().pipe(
              map(settingsSnapshots => {
                let settings = null;
                if (settingsSnapshots && settingsSnapshots.length > 0) {
                  settings = settingsSnapshots[0].payload.doc.data() as Settings;
                  settings.id = settingsSnapshots[0].payload.doc.id;
                }

                const newState: State = {
                  website: website,
                  user: this.user,
                  groupedScheduleItems: this.initScheduleList(website),
                  customFonts: this.processFonts(website),
                  settings: settings
                };

                this.updateState(newState);
                return website;
              })
            );
          }
          return Observable.of(null);
        })
      ).subscribe();
  }



  private getDefaultWebsite() {
    let website = new Website();
    let sixMonthsFromToday = new Date();
    sixMonthsFromToday.setMonth(sixMonthsFromToday.getMonth() + 6);
    website = defaultWebsiteCeline;


    return website;
  }
  scrollToSource(location: string) {
    this.scrollToEditorSource.next(location);
  }
  processFonts(website: Website): any[] {
    let customFonts = [];
    if (website.uploadedFonts) {

      website.uploadedFonts.forEach(font => {

        if (!font.includes("__z__")) {
          return;
        }
        let fontArray = font.split("__z__");
        let fileName = fontArray[1];
        let fontNameExtenstionArray = fontArray[1].split('.');

        fileName = fontNameExtenstionArray[0];

        let fontObj = {
          fontName: fileName,
          fontUrl: font
        }
        customFonts.push(fontObj);

      });

      return customFonts;

    }
  }

  getState(): Observable<State> {
    return this.state$.asObservable();
  }

  sortWeddingEventsByDateIfExists(website: Website) {
    // Early returns for invalid inputs
    if (!website || !website.weddingEvents || !website.weddingEvents.length || website.weddingEvents.length <= 1) {
      return;
    }

    try {
      website.weddingEvents.sort((a, b) => {
        // Safety check for null events
        if (!a || !b) return 0;

        // Handle cases where date-related properties are missing
        const hasDateA = !!(a.startDate || (a.startDateUtc && a.startDateUtc.year && a.startDateUtc.month !== undefined && a.startDateUtc.day !== undefined));
        const hasDateB = !!(b.startDate || (b.startDateUtc && b.startDateUtc.year && b.startDateUtc.month !== undefined && b.startDateUtc.day !== undefined));

        // If either event is missing date info, maintain original order
        if (!hasDateA && !hasDateB) return 0;
        if (!hasDateA) return -1;
        if (!hasDateB) return 1;

        try {
          // Safely get dates for comparison
          let dateA: Date | null = null;
          let dateB: Date | null = null;

          if (a.startDateUtc && a.startDateUtc.year) {
            dateA = new Date(a.startDateUtc.year, a.startDateUtc.month, a.startDateUtc.day);
          } else if (a.startDate) {
            dateA = new Date(a.startDate);
          }

          if (b.startDateUtc && b.startDateUtc.year) {
            dateB = new Date(b.startDateUtc.year, b.startDateUtc.month, b.startDateUtc.day);
          } else if (b.startDate) {
            dateB = new Date(b.startDate);
          }

          // If we couldn't create valid dates, maintain original order
          if (!dateA || !dateB || isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
            return 0;
          }

          // Compare dates
          if (dateA < dateB) return -1;
          if (dateA > dateB) return 1;

          // If dates are equal and both have times, compare times
          if (a.startTime && b.startTime) {
            try {
              const timeA = this.getTimeValuesFromTimeString(a.startTime);
              const timeB = this.getTimeValuesFromTimeString(b.startTime);

              if (timeA && timeB) {
                // Compare hours first
                if (timeA.hours < timeB.hours) return -1;
                if (timeA.hours > timeB.hours) return 1;

                // If hours are equal, compare minutes
                return timeA.minutes - timeB.minutes;
              }
            } catch (error) {
              console.warn('Error comparing times:', error);
            }
          }

          // If we get here, either the dates are equal and there's no valid time comparison,
          // or something went wrong with the time comparison
          return 0;
        } catch (error) {
          console.warn('Error comparing dates:', error);
          return 0;
        }
      });
    } catch (error) {
      console.warn('Error sorting wedding events:', error);
      // If sorting fails, the array remains unchanged
    }
  }

  getTimeValuesFromTimeString(timeString: string) {
    // First check if time includes AM/PM
    const hasAMPM = timeString.match(/[AaPp][Mm]/);
    const timeParts = timeString.match(/(\d+):(\d+)/);
    let hours = parseInt(timeParts[1]);
    const minutes = parseInt(timeParts[2]);

    // If time includes AM/PM, convert to 24 hour format
    if (hasAMPM) {
      const isPM = timeString.toLowerCase().includes('pm');
      if (isPM && hours !== 12) {
        hours += 12;
      } else if (!isPM && hours === 12) {
        hours = 0;
      }
    }

    return {
      hours,
      minutes,
      period: hasAMPM ? (timeString.toLowerCase().includes('pm') ? 'PM' : 'AM') : null
    };
  }

  initScheduleList(website: Website) {
    let groupedScheduleItems: any = [];
    if (!website || !website.schedule || !website.schedule.scheduleItems) {
      return;
    }

    if (website && website.schedule.scheduleItems) {
      // First convert all items to include a proper Date object with time
      const itemsWithDates = website.schedule.scheduleItems.map(item => {
        const timeValues = this.getTimeValuesFromTimeString(item.startTime);

        let fullDate = new Date(item.startDate);
        if (item.startDateUtc && item.startDateUtc.year && item.startDateUtc.month && item.startDateUtc.day) {
          fullDate = new Date(item.startDateUtc.year, item.startDateUtc.month, item.startDateUtc.day);
          item.startDate = fullDate;
        }

        if (item.endDateUtc && item.endDateUtc.year && item.endDateUtc.month && item.endDateUtc.day) {
          item.endDate = new Date(item.endDateUtc.year, item.endDateUtc.month, item.endDateUtc.day);
        }

        fullDate.setHours(timeValues.hours, timeValues.minutes);

        return {
          ...item,
          fullDateTime: fullDate
        };
      });

      // Sort all items by their full date/time
      itemsWithDates.sort((a, b) => a.fullDateTime.getTime() - b.fullDateTime.getTime());

      // Now group them by date
      groupedScheduleItems = itemsWithDates.reduce((grouped, item) => {
        let dateWithoutTime = new Date(item.startDate);

        if (item.startDateUtc && item.startDateUtc.year && item.startDateUtc.month && item.startDateUtc.day) {
          dateWithoutTime = new Date(item.startDateUtc.year, item.startDateUtc.month, item.startDateUtc.day);
        }
        dateWithoutTime.setHours(0, 0, 0, 0);
        const dateStr = dateWithoutTime.toISOString();

        if (!grouped[dateStr]) {
          grouped[dateStr] = [];
        }
        grouped[dateStr].push(item);
        return grouped;
      }, {});

      // Convert to array format
      groupedScheduleItems = Object.keys(groupedScheduleItems).map(dateStr => ({
        date: dateStr,
        items: groupedScheduleItems[dateStr]
      }));

      // Sort the groups by date
      groupedScheduleItems = groupedScheduleItems.sort((a, b) =>
        new Date(a.date).getTime() - new Date(b.date).getTime()
      );

      return groupedScheduleItems;
    }
  }


  updateState(newState: State) {
    this.state$.next(newState);
  }

  addWebsite(website: Website) {
    console.log('add website')
    if (website.defaultMode) {
      website.defaultMode = false;
    }
    this.setCreated(website, this.userId);

    //check no website exists for this userId before adding
    this.firestore.collection<Website>(this.FIRESTORE_WEBSITES_DOCUMENT_COLLECTION_NAME, ref =>
      ref.where('userId', '==', this.userId)
    ).snapshotChanges().take(1).subscribe(x => {

      if (x && x.length > 0 && x[0].payload) {
        const website = x[0].payload.doc.data() as Website;
        website.id = x[0].payload.doc.id;
        console.log('Wedding exists')
        const websiteObject = { ...website };
        const currentState = this.state$.getValue();
        currentState.website = websiteObject;
        this.state$.next(currentState);
      }
      else {
        console.log('create new')
        website.id = this.firestore.createId();
        const websiteObject = { ...website };
        const currentState = this.state$.getValue();
        currentState.website = websiteObject;


        this.firestore.collection(this.FIRESTORE_WEBSITES_DOCUMENT_COLLECTION_NAME).doc(website.id).set(websiteObject)
          .then(() => {
            console.log('Wedding added')

            this.state$.next(currentState);

          })
          .catch(error => console.error('Error adding wedding: ', error));
      }
    });



  }


  preserveDateOnly(date: Date): { year: number, month: number, day: number } {


    // Use local date components and adjust for timezone
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();

    // Create new date at UTC midnight, adjusting for timezone offset    

    return {
      year: year,
      month: month,
      day: day
    }
  }

  processWeddingEventsToShowRsvp(website: Website): boolean {

    if (!website || !website.weddingEvents) {
      return false;
    }
    // Check if all events have collectRsvpsOnWebsite set to false
    const allEventsDoNotCollectRsvp = website.weddingEvents.every(event => !event.collectRsvpsOnWebsite);

    // Set dontShowRsvp to false if all events do not collect RSVPs
    if (allEventsDoNotCollectRsvp) {
      return false;
    } else {
      return true;
    }

  }

  updateSchedule(website: Website) {


  }

  updateWebsiteWithSetupData(website: Website, registry: Registry) {

    if (registry && registry.weddingDay && registry.weddingMonth && registry.weddingYear) {

      let weddingDate = new Date(
        registry.weddingYear,
        registry.weddingMonth - 1,
        registry.weddingDay,
        0,
        0,
        0,
        0
      );
      website.welcome.eventDate = weddingDate;
      let rsvpDeadline = new Date(weddingDate);
      rsvpDeadline.setMonth(rsvpDeadline.getMonth() - 3);

      website.welcome.rsvpDeadline = rsvpDeadline;
      website.welcome.rsvpDeadlineDateUtc = this.preserveDateOnly(rsvpDeadline);

      let today = new Date();
      if (website.welcome.rsvpDeadline <= today) {
        website.welcome.rsvpDeadline = today;
        website.welcome.rsvpDeadlineDateUtc = this.preserveDateOnly(today);
      }
    }
    website.welcome.eventDisplayName = registry.firstName + ' & ' + registry.partnerFirstName;
    website.welcome.eventDisplayNameTranslation = registry.firstName + ' & ' + registry.partnerFirstName;
    //group all the website.schedule.scheduleItems by date 
    // for the first group that is earlier set the date to be 6 months from the wedding date
    // for the second group that is earlier set the date to 6 months + one day from the wedding date

    // Group all the website.schedule.scheduleItems by date
    const { scheduleItems } = website.schedule;
    const weddingDate = new Date(website.welcome.eventDate);
    website.welcome.eventDateUtc = this.preserveDateOnly(weddingDate);
    const groupedItems = scheduleItems.reduce((groups, item) => {
      const dateStr = item.startDate.toISOString().split('T')[0]; // Group by date string
      if (!groups[dateStr]) {
        groups[dateStr] = [];
      }
      groups[dateStr].push(item);
      return groups;
    }, {} as { [key: string]: ScheduleItem[] });

    // Convert groupedItems to an array and sort by date
    const sortedGroups = Object.keys(groupedItems)
      .map(dateStr => ({
        date: new Date(dateStr),
        items: groupedItems[dateStr]
      }))
      .sort((a, b) => a.date.getTime() - b.date.getTime());

    // Set the date for the first group to be 6 months from the wedding date
    if (sortedGroups.length > 0) {
      const firstGroupDate = new Date(weddingDate);

      sortedGroups[0].items.forEach(item => {
        item.startDate = new Date(firstGroupDate);
        item.startDateUtc = this.preserveDateOnly(item.startDate);
        if (item.endDate) {
          // Check if the original end date was one day after the start date
          const originalStartDate = new Date(item.startDate);
          const originalEndDate = new Date(item.endDate);
          const dayDifference = (originalEndDate.getTime() - originalStartDate.getTime()) / (1000 * 3600 * 24);

          if (Math.round(dayDifference) === 1) {
            // If it was one day after, set the end date to wedding date + 1 day
            const newEndDate = new Date(firstGroupDate);
            newEndDate.setDate(newEndDate.getDate() + 1);
            item.endDate = newEndDate;
            item.endDateUtc = this.preserveDateOnly(item.endDate);
          } else {
            // If it wasn't one day after, set it to the same as start date
            item.endDate = new Date(firstGroupDate);
            item.endDateUtc = this.preserveDateOnly(item.endDate);
          }
        }
      });
    }

    // Set the date for the second group to be 6 months + one day from the wedding date
    if (sortedGroups.length > 1) {
      const secondGroupDate = new Date(weddingDate);
      secondGroupDate.setDate(secondGroupDate.getDate() + 1);
      sortedGroups[1].items.forEach(item => {
        item.startDate = new Date(secondGroupDate);
        item.startDateUtc = this.preserveDateOnly(item.startDate);
      });
    }
    // Update the scheduleItems with the new dates using forEach to flatten the array
    let updatedScheduleItems: ScheduleItem[] = [];
    sortedGroups.forEach(group => {
      updatedScheduleItems = updatedScheduleItems.concat(group.items);
    });
    website.schedule.scheduleItems = updatedScheduleItems;


    website.weddingEvents.forEach(event => {
      event.startDate = website.welcome.eventDate;
      event.endDate = website.welcome.eventDate;
      event.startDateUtc = this.preserveDateOnly(event.startDate);
      if (event.endDate) {
        event.endDateUtc = this.preserveDateOnly(event.endDate);
      } else {
        event.endDateUtc = null;
      }
    }
    )
  }

  initWebsite(userId: string, registry: Registry, secondLanguage: string, signupModeWebsite: boolean, signupModeRegistry: boolean, skipAddToFirebase: boolean = false) {
    console.log('init')
    let websiteDefault = this.getDefaultWebsite()
    websiteDefault.isLive = signupModeWebsite;

    if (!registry) {
      // Return a promise that resolves when registry is fetched
      return this.registryFirebaseService.registryByUserId(userId).pipe(

        map(fetchedRegistry => {
          if (fetchedRegistry) {
            registry = fetchedRegistry;
            this.updateWebsiteWithSetupData(websiteDefault, registry);

            if (secondLanguage) {
              this.tranlslateWebsiteIntoSecondLanguage(websiteDefault, secondLanguage);
            }
            if (!this.userId) {
              this.userId = userId;
            }
            if (!skipAddToFirebase) {
              this.addWebsite(websiteDefault);
            }
            return websiteDefault;
          }
        })
      ).toPromise();
    } else {
      this.updateWebsiteWithSetupData(websiteDefault, registry);

      if (secondLanguage) {
        this.tranlslateWebsiteIntoSecondLanguage(websiteDefault, secondLanguage);
      }
      if (!skipAddToFirebase) {
        this.addWebsite(websiteDefault);
      } else {
        return websiteDefault;
      }

    }




  }

  tranlslateWebsiteIntoSecondLanguage(websiteDefault: Website, secondLanguage: string) {





    const translationWebsite: Website = require('./translation-default.' + secondLanguage.toLowerCase() + '.json');

    websiteDefault.questions.sectionNameTranslation = translationWebsite.questions.sectionNameTranslation;
    websiteDefault.registry.sectionNameTranslation = translationWebsite.registry.sectionNameTranslation;
    websiteDefault.schedule.sectionNameTranslation = translationWebsite.schedule.sectionNameTranslation;
    websiteDefault.travel.sectionNameTranslation = translationWebsite.travel.sectionNameTranslation;
    websiteDefault.weddingParty.sectionNameTranslation = translationWebsite.weddingParty.sectionNameTranslation;
    websiteDefault.story.sectionNameTranslation = translationWebsite.story.sectionNameTranslation;


    websiteDefault.announcement.headlineTranslation = translationWebsite.announcement.headlineTranslation;
    websiteDefault.announcement.messageTranslation = translationWebsite.announcement.messageTranslation;

    //iterate through all the  websiteDefault.questions and set the tranlsation text do it using a counter so you can refereance the same index array in the other website qustions array 

    for (let i = 0; i < websiteDefault.questions.questions.length; i++) {
      websiteDefault.questions.questions[i].textTranslation = translationWebsite.questions.questions[i].textTranslation;
      websiteDefault.questions.questions[i].titleTranslation = translationWebsite.questions.questions[i].titleTranslation;
    }

    websiteDefault.registry.leadInTextTranslation = translationWebsite.registry.leadInTextTranslation;


    for (let i = 0; i < websiteDefault.schedule.scheduleItems.length; i++) {
      websiteDefault.schedule.scheduleItems[i].addressTranslation = translationWebsite.schedule.scheduleItems[i].addressTranslation;
      websiteDefault.schedule.scheduleItems[i].descriptionTranslation = translationWebsite.schedule.scheduleItems[i].descriptionTranslation;
      websiteDefault.schedule.scheduleItems[i].attireTranslation = translationWebsite.schedule.scheduleItems[i].attireTranslation;
      websiteDefault.schedule.scheduleItems[i].eventNameTranslation = translationWebsite.schedule.scheduleItems[i].eventNameTranslation;
      websiteDefault.schedule.scheduleItems[i].venueTranslation = translationWebsite.schedule.scheduleItems[i].venueTranslation;

    }

    for (let i = 0; i < websiteDefault.travel.travelInfo.length; i++) {
      websiteDefault.travel.travelInfo[i].notesTranslation = translationWebsite.travel.travelInfo[i].notesTranslation;
      websiteDefault.travel.travelInfo[i].titletranslation = translationWebsite.travel.travelInfo[i].titletranslation;

    }
    websiteDefault.weddingParty.introTranslation = translationWebsite.weddingParty.introTranslation;
    for (let i = 0; i < websiteDefault.weddingParty.partyMembers.length; i++) {
      websiteDefault.weddingParty.partyMembers[i].roleTranslation = translationWebsite.weddingParty.partyMembers[i].roleTranslation;
      websiteDefault.weddingParty.partyMembers[i].storyTranslation = translationWebsite.weddingParty.partyMembers[i].storyTranslation;
    }

    for (let i = 0; i < websiteDefault.weddingEvents.length; i++) {
      websiteDefault.weddingEvents[i].addressTranslation = translationWebsite.weddingEvents[i].addressTranslation;
      websiteDefault.weddingEvents[i].attireTranslation = translationWebsite.weddingEvents[i].attireTranslation;
      websiteDefault.weddingEvents[i].descriptionTranslation = translationWebsite.weddingEvents[i].descriptionTranslation;
      websiteDefault.weddingEvents[i].eventNameTranslation = translationWebsite.weddingEvents[i].eventNameTranslation;
      websiteDefault.weddingEvents[i].venueTranslation = translationWebsite.weddingEvents[i].venueTranslation;
      websiteDefault.weddingEvents[i].attendanceQuestion.optionsTranslation = translationWebsite.weddingEvents[i].attendanceQuestion.optionsTranslation;
      websiteDefault.weddingEvents[i].attendanceQuestion.questionTranslation = translationWebsite.weddingEvents[i].attendanceQuestion.questionTranslation;

      if (translationWebsite &&
        translationWebsite.weddingEvents &&
        translationWebsite.weddingEvents[0] &&
        translationWebsite.weddingEvents[0].rsvpQuestions &&
        translationWebsite.weddingEvents[0].rsvpQuestions[0] &&
        translationWebsite.weddingEvents[i].rsvpQuestions[0].questionTranslation) {
        websiteDefault.weddingEvents[i].rsvpQuestions[0].questionTranslation = translationWebsite.weddingEvents[i].rsvpQuestions[0].questionTranslation;
      }

      // if(translationWebsite.weddingEvents[i].rsvpQuestions[i].optionsTranslation){
      //   websiteDefault.weddingEvents[i].rsvpQuestions[0].optionsTranslation = translationWebsite.weddingEvents[i].rsvpQuestions[0].optionsTranslation;
      // }







      websiteDefault.welcome.greetingsTranslation = translationWebsite.welcome.greetingsTranslation;
      websiteDefault.welcome.rsvpShortNoteTranslation = translationWebsite.welcome.rsvpShortNoteTranslation;
      websiteDefault.story.storyHighlightTranslation = translationWebsite.story.storyHighlightTranslation;
      websiteDefault.story.storyTextTranslation = translationWebsite.story.storyTextTranslation;


    }

  }
  private async getRegistry(userId: string) {
    // Only fetch if we don't have it cached
    if (!this.registry) {
      try {
        const registryRef = this.firestore.collection('registries')
          .ref.where('userId', '==', userId).limit(1);

        const snapshot = await registryRef.get();
        this.afs.collection<Registry>('registries', ref =>
          ref.where('userId', '==', userId)
        ).snapshotChanges();

        if (!snapshot.empty) {

          this.registry = snapshot.docs[0].data() as Registry;

        } else {
          console.log('No registry found for user:', userId);
          this.registry = null;
        }
      } catch (error) {
        console.error('Error fetching registry:', error);
        this.registry = null;
      }
    }

    return this.registry;
  }


  async fixDatesAndRegistry(website: any) {
    // Get registry first
    this.registry = await this.getRegistry(website.userId);

    // Then fix dates

    this.fixDates(website, this.registry);
  }





  updateWebsite(website: Website) {

    if (website.id === null || website.id === undefined) {
      return this.addWebsite(website);
    }
    if (website.defaultMode) {
      website.defaultMode = false;
    }
    //this.settings
    //this.initBeforeSave(website);
    this.setUpdated(website);
    this.fixDatesAndRegistry(website);


    // if(websiteObject.schedule && websiteObject.schedule.scheduleItems){
    // website.schedule.scheduleItems = {...website.schedule.scheduleItems}
    // }

    let websiteObject = { ...website };

    if (website.schedule && website.schedule.scheduleItems) {
      websiteObject.schedule = { ...website.schedule };
      websiteObject.schedule.scheduleItems = website.schedule.scheduleItems.map((obj) => { return Object.assign({}, obj) });
    }


    if (website.weddingEvents && website.weddingEvents.length > 0) {
      websiteObject.weddingEvents = website.weddingEvents.map((obj) => { return Object.assign({}, obj) });

    }

    if (website.weddingEvents && website.weddingEvents.length > 0) {
      websiteObject.weddingEvents = website.weddingEvents.map(event => {
        return {
          addressTranslation: event.addressTranslation ? event.addressTranslation : null,
          attireTranslation: event.attireTranslation ? event.attireTranslation : null,
          descriptionTranslation: event.descriptionTranslation ? event.descriptionTranslation : null,
          eventNameTranslation: event.eventNameTranslation ? event.eventNameTranslation : null,
          venueTranslation: event.venueTranslation ? event.venueTranslation : null,
          attendanceQuestion: event.attendanceQuestion ? Object.assign({}, event.attendanceQuestion) : null,
          startDateUtc: event.startDateUtc ? event.startDateUtc : null,
          endDateUtc: event.endDateUtc ? event.endDateUtc : null,

          isPrivate: event.isPrivate ? event.isPrivate : null,
          collectRsvpsOnWebsite: event.collectRsvpsOnWebsite ? event.collectRsvpsOnWebsite : null,
          rsvpQuestions: event.rsvpQuestions ? event.rsvpQuestions.map((obj) => { return Object.assign({}, obj) }) : null,
          address: event.address ? event.address : null,
          attire: event.attire ? event.attire : null,
          description: event.description ? event.description : null,
          endDate: event.endDate ? event.endDate : null,
          eventName: event.eventName ? event.eventName : null,
          startDate: event.startDate ? event.startDate : null,
          endTime: event.endTime ? event.endTime : null,
          startTime: event.startTime ? event.startTime : null,
          venue: event.venue ? event.venue : null,
          createdDate: event.createdDate ? event.createdDate : null,
          modifiedDate: event.modifiedDate ? event.modifiedDate : null,
          id: event.id ? event.id : null,
        };
      });
    }

    // let requiresTranslation =      this.checkIfRequiresTranslation(websiteObject);

    // if(requiresTranslation){
    //   this.settingsStateStore.translate();
    // }
    this.afs
      .collection(this.FIRESTORE_WEBSITES_DOCUMENT_COLLECTION_NAME).doc(website.id)
      .set(Object.assign({}, websiteObject)
        , { merge: true })
      .then(() => {
        console.log('Wedding updated')
        console.log(website)
      }

      )
      .catch(error => {
        console.error('Error updating wedding: ', error)
      }
      );
  }

  setUndefinedPropertiesToNull(obj: any) {
    for (let key in obj) {
      if (obj[key] === undefined) {
        obj[key] = null;
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        this.setUndefinedPropertiesToNull(obj[key]);
      }
    }
  }
  deleteWebsite(id: string) {
    this.firestore.collection(this.FIRESTORE_WEBSITES_DOCUMENT_COLLECTION_NAME).doc(id).delete()
      .then(() => console.log('Wedding deleted'))
      .catch(error => console.error('Error deleting wedding: ', error));
  }
  emitTranlation(isViewingTranlsation: boolean) {

    this.emitTranslationSource.next(isViewingTranlsation);
  }


  private setCreated(baseObject: BaseObject, userId: string) {
    if (!userId) {
      throw new Error('no user ID supplied: Hitchd crash error');
    }

    const now = Date.now();
    baseObject.createdDate = now;
    baseObject.modifiedDate = now;
    baseObject.userId = userId;
  }
  private setUpdated(baseObject: BaseObject) {
    const now = Date.now();
    baseObject.modifiedDate = now;
  }

  loadFonts(website: Website, document: Document) {
    if (!website || !website.fonts) return;

    // Get unique fonts from website.fonts properties
    const uniqueFonts = Array.from(new Set([
      website.fonts.heading,
      website.fonts.paragraph,
      website.fonts.misc
    ])).filter(Boolean); // Remove any null/undefined values

    // Load custom uploaded fonts
    if (website.uploadedFonts) {
      this.loadCustomFonts(website.uploadedFonts, uniqueFonts, document);
    }

    // Load Google fonts
    this.loadGoogleFonts(this.googleFonts, uniqueFonts, document);
  }

  private loadCustomFonts(uploadedFonts: string[], uniqueFonts: string[], document: Document) {
    uploadedFonts.forEach(font => {

      if (!font.includes("__z__")) {
        return;
      }
      const fontArray = font.split("__z__");
      const fontNameExtensionArray = fontArray[1].split('.');
      const fontName = fontNameExtensionArray[0];

      // Only load if font is being used and not already loaded
      if (uniqueFonts.includes(fontName) && !document.getElementById(`font-style-${fontName}`)) {
        const style = document.createElement('style');
        style.id = `font-style-${fontName}`;
        style.textContent = `
          @font-face {
            font-family: '${fontName}';
            src: url('${font}')${font.endsWith('.woff2') ? " format('woff2')" : ''};
            font-display: swap;
          }
        `;
        document.head.appendChild(style);
      }
    });
  }

  private loadGoogleFonts(googleFonts: any[], uniqueFonts: string[], document: Document) {
    uniqueFonts.forEach(fontName => {
      if (document.getElementById(`font-style-${fontName}`)) {
        return;
      }

      const fontData = googleFonts.find(font => font.name === fontName);

      if (!fontData) {
        throw new Error(`Font "${fontName}" not found in Google Fonts list. Please check the font name and ensure it exists in the available fonts.`);
      }

      const style = document.createElement('style');
      style.id = `font-style-${fontName}`;
      style.textContent = `
        @font-face {
          font-family: '${fontName}';
          src: url('${fontData.file}')${fontData.file.endsWith('.woff2') ? " format('woff2')" : ''};
          font-display: swap;
        }
      `;
      document.head.appendChild(style);
    });
  }

  getLanguageCode(language: string): string {
    if (!language) return 'EN';

    switch (language.toLowerCase()) {
      case 'czech':
        return 'CS';
      case 'danish':
        return 'DA';
      case 'dutch':
        return 'NL';
      case 'estonian':
        return 'ET';
      case 'finnish':
        return 'FI';
      case 'french':
        return 'FR';
      case 'german':
        return 'DE';
      case 'greek':
        return 'EL';
      case 'hungarian':
        return 'HU';
      case 'italian':
        return 'IT';
      case 'latvian':
        return 'LV';
      case 'lithuanian':
        return 'LT';
      case 'luxembourgish':
        return 'LB';
      case 'norwegian':
        return 'NO';
      case 'polish':
        return 'PL';
      case 'portuguese':
        return 'PT';
      case 'slovak':
        return 'SK';
      case 'slovenian':
        return 'SL';
      case 'spanish':
        return 'ES';
      case 'swedish':
        return 'SV';
      default:
        return 'EN';
    }
  }



  extractDateOnly(originalDate: Date): Date {

    const year = originalDate.getFullYear();
    const month = originalDate.getMonth(); // Note: Months are zero-indexed
    const day = originalDate.getDate();

    // Create a new Date object with the extracted values
    const dateOnly = new Date(year, month, day);

    // Set the time to midnight to minimize timezone impact
    dateOnly.setHours(0, 0, 0, 0);

    return dateOnly;
  }

  formatDateForCountry(isoDate: string, countryCode: string): Date {
    const timezone = this.getTimezoneFromCountryCode(countryCode);

    const formattedDate = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      // timeZoneName: 'short' // uncomment to show timezone
    }).format(new Date(isoDate));

    return new Date(formattedDate);


  }
  getTimezoneFromCountryCode(countryCode: string): string {
    // Country code to timezone mappings
    const countryTimezones: { [key: string]: string } = {
      'AU': 'Australia/Sydney',
      'AT': 'Europe/Vienna',
      'BE': 'Europe/Brussels',
      'CA': 'America/Toronto',
      'EE': 'Europe/Tallinn',
      'DK': 'Europe/Copenhagen',
      'FI': 'Europe/Helsinki',
      'FR': 'Europe/Paris',
      'DE': 'Europe/Berlin',
      'GR': 'Europe/Athens',
      'HK': 'Asia/Hong_Kong',
      'IE': 'Europe/Dublin',
      'IT': 'Europe/Rome',
      'LV': 'Europe/Riga',
      'LT': 'Europe/Vilnius',
      'LU': 'Europe/Luxembourg',
      'MX': 'America/Mexico_City',
      'NL': 'Europe/Amsterdam',
      'NZ': 'Pacific/Auckland',
      'NO': 'Europe/Oslo',
      'PT': 'Europe/Lisbon',
      'SG': 'Asia/Singapore',
      'SK': 'Europe/Bratislava',
      'SI': 'Europe/Ljubljana',
      'ES': 'Europe/Madrid',
      'SE': 'Europe/Stockholm',
      'CH': 'Europe/Zurich',
      'GB': 'Europe/London',
      'US': 'America/New_York'
    };

    return countryTimezones[countryCode.toUpperCase()] || 'UTC';
  }

  // Process all image URLs in the website to migrate domains
  private processWebsiteImageUrls(website: Website): Website {
    if (!website) return website;

    try {
      // Ensure imageUrlService is available
      if (!this.imageUrlService) {
        console.warn('ImageUrlService not available, skipping URL processing');
        return website;
      }

      // Process welcome section hero image
      if (website.welcome && website.welcome.heroImageUrl && typeof website.welcome.heroImageUrl === 'string') {
        const processedUrl = this.imageUrlService.migrateDomainOnly(website.welcome.heroImageUrl);
        if (processedUrl) {
          website.welcome.heroImageUrl = processedUrl;
        }
      }

      // Process story images
      if (website.story) {
        if (website.story.imageUrl && typeof website.story.imageUrl === 'string') {
          const processedUrl = this.imageUrlService.migrateDomainOnly(website.story.imageUrl);
          if (processedUrl) {
            website.story.imageUrl = processedUrl;
          }
        }
        if (website.story.imageUrl2 && typeof website.story.imageUrl2 === 'string') {
          const processedUrl = this.imageUrlService.migrateDomainOnly(website.story.imageUrl2);
          if (processedUrl) {
            website.story.imageUrl2 = processedUrl;
          }
        }
        if (website.story.imageUrl3 && typeof website.story.imageUrl3 === 'string') {
          const processedUrl = this.imageUrlService.migrateDomainOnly(website.story.imageUrl3);
          if (processedUrl) {
            website.story.imageUrl3 = processedUrl;
          }
        }
        if (website.story.imageUrl4 && typeof website.story.imageUrl4 === 'string') {
          const processedUrl = this.imageUrlService.migrateDomainOnly(website.story.imageUrl4);
          if (processedUrl) {
            website.story.imageUrl4 = processedUrl;
          }
        }
        if (website.story.imageUrl5 && typeof website.story.imageUrl5 === 'string') {
          const processedUrl = this.imageUrlService.migrateDomainOnly(website.story.imageUrl5);
          if (processedUrl) {
            website.story.imageUrl5 = processedUrl;
          }
        }
        if (website.story.imageUrl6 && typeof website.story.imageUrl6 === 'string') {
          const processedUrl = this.imageUrlService.migrateDomainOnly(website.story.imageUrl6);
          if (processedUrl) {
            website.story.imageUrl6 = processedUrl;
          }
        }
      }

      // Process wedding party member images
      if (website.weddingParty && Array.isArray(website.weddingParty.partyMembers)) {
        website.weddingParty.partyMembers.forEach((member, index) => {
          if (member && member.imageUrl && typeof member.imageUrl === 'string') {
            try {
              const processedUrl = this.imageUrlService.migrateDomainOnly(member.imageUrl);
              if (processedUrl) {
                member.imageUrl = processedUrl;
              }
            } catch (error) {
              console.warn(`Failed to process wedding party member ${index} image URL:`, error);
            }
          }
        });
      }

    } catch (error) {
      console.warn('Error processing website image URLs:', error);
      // Return original website if processing fails
    }

    return website;
  }
}






// WEBPACK FOOTER //
// ./src/app/website-builder/website.state.store.ts